import {
    Mail,
    Phone,
    MapPin,
    Clock,
    Instagram,
    Facebook
} from "react-feather";

import "./Footer.css";

function Footer() {
    return (
        <footer className="footer">

            <div className="footer-container">

                <div className="footer-main">

                    <div className="footer-brand">

                        <h2>3 Point Signs</h2>

                        <p>
                            Custom signage solutions designed, fabricated and installed
                            with attention to quality, detail and long-term performance.
                        </p>

                        <div className="footer-socials">

                            <a
                                href="https://www.instagram.com/"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="Instagram"
                            >
                                <Instagram size={20} />
                            </a>

                            <a
                                href="https://www.facebook.com/"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="Facebook"
                            >
                                <Facebook size={20} />
                            </a>

                        </div>

                    </div>

                    <div className="footer-column">

                        <h3>Quick Links</h3>

                        <nav className="footer-links">
                            <a href="#about">About</a>
                            <a href="#services">Services</a>
                            <a href="#projects">Projects</a>
                            <a href="#whyus">Why Us</a>
                            <a href="#contact">Contact</a>
                        </nav>

                    </div>

                    <div className="footer-column">

                        <h3>Services</h3>

                        <div className="footer-services">
                            <span>Channel Letters</span>
                            <span>Cabinet Signs</span>
                            <span>Pylon Signs</span>
                            <span>Window Graphics</span>
                            <span>Custom Fabrication</span>
                            <span>Installation</span>
                        </div>

                    </div>

                    <div className="footer-column footer-contact">

                        <h3>Contact</h3>

                        <a href="mailto:hello@3pointsigns.com">
                            <Mail size={19} />
                            <span>info@3pointsigns.com</span>
                        </a>

                        {/* <a>
                            <Phone size={19} />
                            <span>Provided after 1st Email</span>
                        </a> */}

                        <div className="footer-contact-item">
                            <MapPin size={19} />
                            <span>Montreal, Quebec</span>
                        </div>

                        <div className="footer-contact-item">
                            <Clock size={19} />
                            <span>Monday–Friday, 8:00 AM–5:00 PM</span>
                        </div>

                    </div>

                </div>

                <div className="footer-bottom">

                    <p>
                        © {new Date().getFullYear()} 3 Point Signs. All rights reserved.
                    </p>

                    <p>
                        Design · Fabrication · Installation
                    </p>

                </div>

            </div>

        </footer>
    );
}

export default Footer;